export default {"src":"/_next/static/media/multiple-choice.f446ba6c.svg","height":40,"width":40};